import { registerLocale } from "i18n-iso-countries";
import React from "react";

import { AmplitudeClient } from "amplitude-js";
import { Client as BugsnagClient } from "@bugsnag/js";

registerLocale(require("i18n-iso-countries/langs/en.json"));

export const amplitudeClient: AmplitudeClient | undefined =
  typeof window !== "undefined"
    ? require("./bootstrap-client").amplitudeClient
    : undefined;

export const DEVICE_ID = amplitudeClient?.options.deviceId;

export const bugsnagClient: BugsnagClient =
  typeof window !== "undefined"
    ? require("./bootstrap-client").bugsnagClient
    : require("./bootstrap-server").bugsnagClient;

export const ErrorBoundary: React.FC =
  typeof window !== "undefined"
    ? require("./bootstrap-client").ErrorBoundary
    : require("./bootstrap-server").ErrorBoundary;
